import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import demandService from '../../api/demandsService';

export default class ConfirmDeleteCompany extends Component {
    constructor(props) {
        super(props);

        this.deleteDemand = this.deleteDemand.bind(this);
    }

    deleteDemand() {
        const { id } = this.props.demand;
        demandService.deleteDemand(id)
            .then(() => {
                this.props.onClose();
            });
    }

    render() {
        const { showConfirm, onClose, demand } = this.props;
        if (demand) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete this Demand?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are deleting?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back.</Button>
                        <Button onClick={this.deleteDemand} color="primary" autoFocus>Yes, delete.</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}